import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getToken } from "../../auth/authConfig";
import axios from "axios";
import "../ScoringDetails/ScoringDetails.scss";
import TopSection from "./TopSection";
import BottomSection from "./BottomSection";
import { Alert, Box, CircularProgress, Modal, Snackbar } from "@mui/material";
import { useRecoilValue } from "recoil";
import {
  scoringSubmit,
  switchProtocolType,
} from "../../../store/audit details/atom";
import submitGif from "../../../assets/img/submit.gif";
import VersioningAuditProtocolScoringExcel from "../../reusables/VersioningAuditProtocolScoringExcel";
import { login } from "../../auth/msalAuth";

const VersioningScoringDetails = () => {
  const [scoringData, setScoringData] = useState(null);
  const [scoringLoading, setScoringLoading] = useState(false);
  const [scoringError, setScoringError] = useState(null);
  const [fsscScore1, setFsscScore1] = useState(null);
  const [qmsScore1, setQmsScore1] = useState(null);
  const [fsscScore2, setFsscScore2] = useState(null);
  const [qmsScore2, setQmsScore2] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [version1, setVersion1] = useState(true);
  const [version2, setVersion2] = useState(false);
  const [isCertification1, setIsCertification1] = useState(false);
  const [isCertification2, setIsCertification2] = useState(false);
  const [auditDetailsData, setAuditDetailsData] = useState({});
  const [protocolDetails, setProtocolDetailsData] = useState({});
  const [version2ScoringData, setVersion2ScoringData] = useState({});
  const [attendiesInArrayFormat, setAttendiesInArrayFormat] = useState([]);
  const [correctionDate, setCorrectionDate] = useState("");
  const [ffscRecommended1, setFfscRecommended1] = useState(null);
  const [ffscRecommended2, setFfscRecommended2] = useState(null);
  const [unitDetails, setUnitDetails] = useState([]);
  const [unitIndex, setUnitIndex] = useState("");
  const [error, setError] = useState(false);

  const getSotredProtocolType = useRecoilValue(switchProtocolType);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const scoringSubmitValue = useRecoilValue(scoringSubmit);

  const [searchParams] = useSearchParams();
  const auditNumber = searchParams.get("auditNumber");
  // const auditNumber = "2025-0082";

  console.log("scoi data", scoringData);

  function transformData(inputArray) {
    if (!Array.isArray(inputArray) || inputArray.length === 0) return [];

    console.log("inpute array", inputArray);

    const data = inputArray[0]; // Extract first object

    return {
      transformedData: [
        {
          id: 1,
          results: "Criticals",
          numOfNonComf: data?.critical ? String(data.critical) : 0,
          nonComfPoints: data?.criticalScore ? String(data.criticalScore) : 0,
        },
        {
          id: 2,
          results: "Majors",
          numOfNonComf: data?.major ? String(data.major) : 0,
          nonComfPoints: data?.majorScore ? String(data.majorScore) : 0,
        },
        {
          id: 3,
          results: "Minors",
          numOfNonComf: data?.minor ? String(data.minor) : 0,
          nonComfPoints: data?.minorScore ? String(data.minorScore) : 0,
        },
      ],
      totalNonConformanceScore: data?.totalNonConformanceScore,
      isFfscCertificationRecommended: data?.isFfscCertificationRecommended,
      id: data?.id,
      formId: data?.formId,
    };
  }

  const changeCertificationHandler = (radioValue) => {
    postScores(radioValue);
  };

  console.log("scoringDate is here", scoringData);

  const postScores = async (radioValue) => {
    const postScoringURL = `${process.env.REACT_APP_SERVER_URL}/api/versioning/change_fssc
 `;
    const token = await getToken();
    setScoringLoading(true);
    try {
      const response = await axios.post(
        postScoringURL,
        {
          formId: auditNumber,
          newRecommendationFssc:
            radioValue
        },
        {
          headers: {
            "oidc-token": token,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.status === 200) {
        const data = response.data;
        // setScoringData((prev) => ({
        //   ...prev,
        //   auditConclusion: {
        //     conformanceLevel: data.conformanceLevel,
        //   },
        // }));

        const updatedScoringData = scoringData.map((item, index) => ({
          ...item,
          audit_conclusion: {
            ...item.audit_conclusion,
            conformance_level:
              index === 1
                ? data.conformanceLevel
                : item.audit_conclusion.conformance_level, // Change only the second object
          },
          fssc_score: item.fssc_score.map((fssc) => ({
            ...fssc,
            isFfscCertificationRecommended:
              radioValue.toLowerCase() === "yes" ? true : false,
          })),
        }));

        setScoringData(updatedScoringData);

        setVersion2ScoringData((prev) => ({
          ...prev,
          fssc_score: {
            ...prev.fssc_score,
            isFfscCertificationRecommended:
              radioValue.toLowerCase() === "yes" ? true : false,
          },
        }));
        setScoringLoading(false);
      } else {
        setScoringError("Oops! Something went wrong. . .");
      }
    } catch (e) {
      setScoringLoading(false);
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      setScoringError("Oops! Something went wrong. . .");
    } finally {
      setScoringError(false);
    }
  };

  const getScoringDetails = async () => {
    const getScoringURL = `${process.env.REACT_APP_SERVER_URL}/api/versioning/get_score/${auditNumber}`;
    const token = await getToken();
    setScoringLoading(true);
    try {
      const response = await axios.get(getScoringURL, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        setScoringData(response.data);
        console.log("res", response.data[0]);
        setVersion2ScoringData(response.data[1]);
        setScoringLoading(false);
        let fsscArr1 = transformData(response?.data[0]?.fssc_score);
        setFfscRecommended1(
          response?.data[0]?.fssc_score[0].isFfscCertificationRecommended
        );

        setFsscScore1(fsscArr1);
        let qmsArr1 = transformData(response?.data[0]?.qms_score);
        setQmsScore1(qmsArr1);
        let fsscArr2 = transformData(response?.data[1]?.fssc_score);
        setFsscScore2(fsscArr2);
        setFfscRecommended2(
          response?.data[1]?.fssc_score[0].isFfscCertificationRecommended
        );
        let qmsArr2 = transformData(response?.data[1]?.qms_score);
        setQmsScore2(qmsArr2);
        if (response?.data[0]?.isFsscConjuction) {
          setIsCertification1(response?.data[0]?.isFsscConjuction);
        }
        if (response?.data[1]?.isFsscConjuction) {
          setIsCertification2(response?.data[1]?.isFsscConjuction);
        }
        setLoading(false);
      } else {
        setScoringError("Oops! Something went wrong. . .");
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      setScoringLoading(false);
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      setScoringError("Oops! Something went wrong. . .");
    } finally {
      setScoringError(false);
    }
  };

  const handleVersion2 = () => {
    if (!version2) {
      const right = document.querySelector(".tab-right");
      const left = document.querySelector(".tab-left");
      left.classList.remove("tab-active");
      right.classList.add("tab-active");
      setVersion2(true);
      setVersion1(false);
    }
  };

  const hanldeVersion1 = () => {
    if (!version1) {
      const left = document.querySelector(".tab-left");
      const right = document.querySelector(".tab-right");
      left.classList.add("tab-active");
      right.classList.remove("tab-active");
      setVersion2(false);
      setVersion1(true);
    }
  };

  const unitDetailsInfo = async () => {
    const viewUrl = `${process.env.REACT_APP_SERVER_URL}/super/view_forms/${auditNumber}`;
    const token = await getToken();
    try {
      setLoading(true);
      const response = await axios.get(viewUrl, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });
      if (response.status === 200) {
        const data = response.data;
        const unit_index = data?.unitIndex;
        const combinedData = [
          ...data.unitDetails.unitDetails,
          ...data.unitDetails.offSiteFields,
        ];
        if (combinedData) {
          setUnitDetails(combinedData);
        }
        if (unit_index) {
          setUnitIndex(unit_index);
        }

        console.log("combine data", combinedData);
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }

      console.log("getting error while calling the api");
    }
  };

  const getAuditDetailsData = async () => {
    try {
      // setloading(true);

      const url = `${process.env.REACT_APP_SERVER_URL}/api/forms/get_audit/${auditNumber}`;
      const token = await getToken();

      const response = await axios.get(url, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        const json = response.data;
        if (json) {
          setAuditDetailsData(json);
        }
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      console.error("Error while calling the API:", e);
      // setloading(false);
    }
  };

  const getProtocolData = async () => {
    try {
      setLoading(true);

      if (auditNumber) {
        const url = `${process.env.REACT_APP_SERVER_URL}/api/versioning/get_protocol/${auditNumber}`;

        const token = await getToken();

        const response = await axios.get(url, {
          headers: {
            "oidc-token": token,
            Accept: "application/json",
          },
        });

        if (response.status === 200) {
          const json = response.data;

          if (json) {
            // setFormData(json);
            setProtocolDetailsData(json);
          }
        }
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      console.error("Error while calling the API:", e);
      setLoading(false);

      // setloading(false);
    }
  };

  const getCorrectionDate = async () => {
    try {
      // setDataLoading(true);

      const url = `${process.env.REACT_APP_SERVER_URL}/api/versioning/get_audit/${auditNumber}`;
      const token = await getToken();

      const response = await axios.get(url, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        const json = response.data;
        // setFormData(json?.auditDetails);
        if (json?.correctionDate) {
          setCorrectionDate(json.correctionDate);
        }
        // setDataLoading(false);
      }
    } catch (error) {
      // setDataLoading(false);
      console.error("Error while calling the API:", error);
      // setloading(false);
    }
  };
  useEffect(() => {
    getScoringDetails();
    getCorrectionDate();
    getAuditDetailsData();
    getProtocolData();
    unitDetailsInfo();
  }, []);
  useEffect(() => {
    let attendiesDetails = auditDetailsData?.audit_team || {};
    // Validate if attendiesDetails is not an empty object
    const result =
      Object.keys(attendiesDetails).length > 0
        ? Object.keys(attendiesDetails).map((key) => ({
            name: key, // Use the key as the name
            function: attendiesDetails[key],
          }))
        : []; // If it's empty, return an empty array

    // Set the result to state
    setAttendiesInArrayFormat(result);
  }, [scoringData, auditDetailsData]);
  return (
    <>
      {loading ? (
        <Modal open={loading}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh", // Full viewport height
              width: "100%",
              flexDirection: "column",
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
              backdropFilter: "blur(5px)", // Adding a blur effect for the background
              borderRadius: "10px", // Rounded corners
              padding: "20px",
            }}
          >
            <CircularProgress color="secondary" sx={{ marginBottom: "20px" }} />
            <h3
              style={{
                color: "white",
                fontSize: "18px",
                fontWeight: "500",
              }}
            >
              Loading... Please wait
            </h3>
          </Box>
        </Modal>
      ) : (
        <>
          {scoringSubmitValue ? (
            <div className="submitGif-box">
              <img src={submitGif} alt="submitgif" />
            </div>
          ) : (
            <>
              <div id="custom-tabs">
                <button
                  // disabled={buttonsDisable}
                  onClick={hanldeVersion1}
                  className="tab-left tab-active "
                >
                  Version1
                </button>
                <button
                  // disabled={buttonsDisable}
                  onClick={handleVersion2}
                  className=" tab-right"
                >
                  Version2
                </button>
              </div>

              {version1 && (
                <div id="main-scoring-details">
                  <TopSection
                    fsscScore={fsscScore1}
                    qmsScore={qmsScore1}
                    scoringLoading={scoringLoading}
                    onChangeCertification={changeCertificationHandler}
                    disable="true"
                    isCertification={isCertification1}
                    protocolDetails={protocolDetails}
                    ffscRecommended={ffscRecommended1}
                    changedffscRecommended={setFfscRecommended1}
                  />
                  <BottomSection
                    scoringData={scoringData && scoringData[0].audit_conclusion}
                    scoringLoading={scoringLoading}
                    auditNumber={auditNumber}
                    isDisabled={true}
                  />
                </div>
              )}
              {version2 && (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      paddingBottom: "10px",
                    }}
                  >
                    <VersioningAuditProtocolScoringExcel
                      auditData={auditDetailsData}
                      protocolData={protocolDetails}
                      fileName={`${unitIndex}_${auditNumber}_${new Date().getTime()}`}
                      // // transformData={transformData}
                      sheetNames={[
                        "Unit Details",
                        "Audit details",
                        "Protocol details",
                        "Scoring details",
                        "Areas of Concern",
                        "PY-Areas of Concern",
                        "FSSC Findings",
                        "PY-FSSC Findings",
                      ]}
                      color="ff8200"
                      // exportPosition={true}
                      className="export-btn"
                      scoringData={version2ScoringData}
                      protocolType={getSotredProtocolType}
                      auditFocusArea={auditDetailsData?.audit_focus_area}
                      protocolFocusArea={protocolDetails?.focus_area}
                      additionalAttendees={attendiesInArrayFormat}
                      versioning={true}
                      isCertification={isCertification2}
                      correctionDate={correctionDate}
                      ffscRecommended={ffscRecommended2}
                      unitDetails={unitDetails}
                    />
                  </div>
                  <div id="main-scoring-details">
                    <TopSection
                      fsscScore={fsscScore2}
                      qmsScore={qmsScore2}
                      scoringLoading={scoringLoading}
                      onChangeCertification={changeCertificationHandler}
                      isCertification={isCertification2}
                      protocolDetails={protocolDetails}
                      version2Disabled={true}
                      disable="true"
                      ffscRecommended={ffscRecommended2}
                      changedffscRecommended={setFfscRecommended2}
                    />
                    <BottomSection
                      scoringData={
                        scoringData && scoringData[1].audit_conclusion
                      }
                      scoringLoading={scoringLoading}
                      auditNumber={auditNumber}
                      setVersion2ScoringData={setVersion2ScoringData}
                      version2Disabled={true}
                      isDisabled={true}
                      hideSubmit={true}
                    />
                  </div>
                </>
              )}
            </>
          )}
        </>
      )}
      {error && (
        <Box
          sx={{
            position: "fixed",
            top: 55,
            right: 16,
            zIndex: 1300, // Ensures it appears above other content
          }}
        >
          <Alert
            severity="error"
            sx={{
              fontSize: "20px",
              width: "auto",
            }}
          >
            Something went wrong! Please try again later.
          </Alert>
        </Box>
      )}
    </>
  );
};

export default VersioningScoringDetails;
